import * as api from 'common/api'

// 学校列表
export let list = params => api.get('account/channel/school/list', params)

// 获取学校信息
export let get = params => api.get('account/channel/school/edit', params)

// 创建/修改学校信息
export let edit = school => api.post('account/channel/school/edit', school)



// WEBPACK FOOTER //
// ./src/api/school.js